import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/it';

dayjs.extend(utc);

dayjs.extend(timezone);

dayjs.extend(customParseFormat);

dayjs.locale('it');

dayjs.tz.setDefault('Europe/Rome');

export default dayjs;

export enum DateFormats {
  dayWithTime = 'YYYY-MM-DD HH:mm:ss',
}
